<template>
  <section class="extra">
    <h2 v-if="extraBenefit.length">Extra Benefits</h2>
    <div
      v-for="(item, i) in extraBenefit"
      :key="i">
      <v-checkbox
        v-model="item.new_p.content.is_enable"
        @change="changeData">{{item.name}}</v-checkbox>
      <section
        v-if="item.new_p.content.is_enable"
        class="extra_table">
        <div class="tr-container bar">
          <div class="tr">
            <span class="bold">Remaining Amount</span>
          </div>
          <div
            class="tr">
            <span class="bold">New Amount</span>
          </div>
        </div>
        <div
          v-for="(subItem, index) in item.new_p.content.keys"
          :key="index"
          :class="{'bar bold': subItem.type == 2 && subItem.endorse_not_show != 1, 'no-border':subItem.endorse_not_show == 1}"
          class="tr-container">
          <template
            v-if="subItem.key != 'handling_fee' && subItem.endorse_not_show != 1">
            <!-- old -->
            <div class="tr">
              <span>{{subItem.name}}{{subItem.type==4?` (${item.old_p.content[subItem.key2]*100}%)`:''}}</span>
              <template v-if="subItem.type == 3">
                <span class="text-center">{{item.old_p.content[subItem.key] | formatPct }}</span>
                <span class="text-right">{{item.old_p.content[subItem.key2] | formatMoney(2, true)}}</span>
              </template>
              <!--              <span-->
              <!--                  v-if="item.type == 4"-->
              <!--                  class="text-right">-->
              <!--                  {{item.old_p.content[subItem.key] | formatMoney(2, true)}}-->
              <!--                </span>-->
              <template v-else>
                <span class="text-right">{{item.old_p.content[subItem.key] | formatMoney(2, true)}}</span>
              </template>
            </div>

            <!-- new -->
            <div class="tr">
              <span>{{subItem.name}}{{subItem.type==4?` (${item.new_p.content[subItem.key2]*100}%)`:''}}</span>
              <div class="flex flex-algin">
                <span v-if="subItem.type == 1">
                  <el-form-item>
                    <v-input
                      v-model="item.new_p.content[subItem.key]"
                      :disabled="(!subItem.enable && !manual_quote) || info"
                      prepend="$"
                      :keyFloatNumber="true"
                      maxlength="8"
                      @blur="changeData" />
                  </el-form-item>
                </span>
                <span
                  v-if="subItem.type == 2">
                  {{item.new_p.content[subItem.key] | formatMoney(2, true)}}
                </span>
                <span
                  v-if="subItem.type == 3">
                  <el-form-item>
                    <v-input
                      v-model="item.new_p.content[subItem.key]"
                      :disabled="(!subItem.enable && !manual_quote) || info"
                      append="%"
                      :keyFloatNumber="true"
                      maxlength="8"
                      @blur="changeData" />
                  </el-form-item>
                </span>
                <span
                  v-if="subItem.type == 3"
                  class="right-width">{{item.new_p.content[subItem.key2] | formatMoney(2, true)}}</span>
                <span
                  v-if="subItem.type == 4"
                  class="text-right">
                  {{item.new_p.content[subItem.key] | formatMoney(2, true)}}
                </span>
              </div>
            </div>
          </template>
        </div>
        <div class="tr-container bar bold">
          <div class="tr">
            <span class="bold amount_title">Amount</span>
            <span class="text-right">{{item.old_p.content.payable | formatMoney(2, true)}}</span>
          </div>
          <div class="tr">
            <span class="bold amount_title">Amount</span>
            <span class="text-right">{{item.new_p.content.premium | formatMoney(2, true)}}</span>
          </div>
        </div>
        <div class="tr-container">
          <div class="tr">
            <span class="bold way">
              Way
              <v-radio-group
                v-model="item.new_p.content.way"
                :list="wayList"
                :disabled="isAdjust"
                @change="changeData" />
            </span>
          </div>
        </div>
        <div class="tr-container">
          <div class="tr">
            <span class="bold amount_title">Remaining Amount</span>
            <span
              v-if="item.new_p.content.way == 1"
              class="day">
              <v-input
                v-model="item.old_p.content.remaining_days"
                :disabled="info"
                clearable
                @blur="changeData"/> / <v-input
                  v-model="item.old_p.content.cycle"
                  :disabled="info||isAdjust"
                  clearable
                  @blur="changeData" />
            </span>
            <span
              v-if="item.new_p.content.way == 2"
              class="percent">
              <v-input
                v-model="item.old_p.content.remaining_day_rate"
                :disabled="info||isAdjust"
                append="%"
                :keyFloatNumber="true"
                maxlength="8"
                @blur="changeData"
              />
            </span>
            <b class="text-right">{{item.old_p.content.remaining_premium | formatMoney(2, true)}}</b>
          </div>
          <div class="tr">
            <span class="bold amount_title">Remaining Amount</span>
            <span
              v-if="item.new_p.content.way == 1"
              class="day">
              <v-input
                v-model="item.new_p.content.remaining_days"
                :disabled="info||isAdjust"
                clearable
                @blur="changeData"/> / <v-input
                  v-model="item.new_p.content.cycle"
                  :disabled="info"
                  clearable
                  @blur="changeData" />
            </span>
            <span
              v-if="item.new_p.content.way == 2"
              class="percent">
              <v-input
                v-model="item.new_p.content.remaining_day_rate"
                :disabled="info||isAdjust"
                append="%"
                :keyFloatNumber="true"
                maxlength="8"
                @blur="changeData"
              />
            </span>
            <b class="text-right">{{item.new_p.content.remaining_premium | formatMoney(2, true)}}</b>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import MixinFormat from '@/mixins/format'

export default {
  name: 'EndorsementExtraBenefitTable',
  mixins: [MixinFormat],
  props:{
    oldExtraBenefit:{
      type: [Object, Array],
      default: null
    },
    newExtraBenefit:{
      type: [Object, Array],
      default: null
    },
    oldExtraBenefitContent:{
      type: [Object, Array],
      default: null
    },
    info:{
      type: Boolean,
      default: false
    },
    isAdjust:{
      type: Boolean,
      default: false
    },
    manual_quote: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      extraBenefit:[],
      extra_premium: {},
      wayList:[
        {
          name: 'Days',
          id: 1
        },
        {
          name: 'Percentage',
          id: 2
        }
      ],
      extra: {}
    }
  },
  watch:{
    oldExtraBenefitContent:{
      immediate: true,
      handler(val){
        if(val){
          // 如果detail里面没有对应的extra benefit，则从result的extra_benefits_premium获取对应old extra benefit
          Object.keys(val).forEach(valKey => {
            if(this.oldExtraBenefit[valKey]){
              Object.assign(this.oldExtraBenefit[valKey].content, {...val[valKey].content})
            }else{
              this.oldExtraBenefit[valKey] = val[valKey]
            }
          })
        }
      }
    },
    newExtraBenefit:{
      immediate: true,
      handler(){
        if(this.newExtraBenefit){
          let arr = []
          let obj = {}
          Object.keys(this.newExtraBenefit).forEach(newKey => {
            Object.keys(this.oldExtraBenefit).forEach(oldKey => {
              if(newKey == oldKey){
                obj = {
                  new_p: {},
                  old_p: {},
                  name: '',
                  key: '',
                  id: ''
                }
                obj.new_p = this.newExtraBenefit[newKey]
                obj.old_p = this.oldExtraBenefit[oldKey]
                obj.name = this.newExtraBenefit[newKey].name
                obj.key = this.newExtraBenefit[newKey].key
                obj.id = this.newExtraBenefit[newKey].id
              }
            })
            arr.push(obj)
          })
          this.extraBenefit = arr
          this.dataProcess()
          this.$emit('dataProcess',this.extraBenefit)
        }
      }
    }
  },
  methods: {
    changeData(){
      this.dataProcess()
      this.$emit('updatePremium', this.extra)
    },

    dataProcess(){
      let extra = {
        new_premium: {},
        old_premium: {}
      }
      this.extraBenefit.map(item => {
        let is_enable = item.new_p.content.is_enable
        item.old_p.content.is_enable = is_enable? 1 : 0
        extra.new_premium[item.key] = item.new_p
        extra.old_premium[item.key] = item.old_p
      })
      this.extra = extra
    }
  },
}
</script>
<style lang='scss' scoped>
.extra{
  margin-top: 20px;
}
.extra_table {
    width: 100%;
    border: 1px solid #e1e4e8;
    border-radius: 8px;
    margin: 10px 0;
    .tr-container {
      display: flex;
      border-bottom: 1px solid #e1e4e8;
      &:last-child {
        border-bottom: 0;
      }
      &.bar {
        background: #f6f8fa;
      }
      &.no-border{
        border: 0;
      }
      &:first-child{
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }
      &:last-child{
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }
      .tr {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        font-size: 14px;
        color: #24292e;
        line-height: 17px;
        & > span {
          flex: 1;
        }
        &:nth-child(2) {
          border-left: 1px solid #E1E4E8;;
        }
        b{
          width: 100px;
        }
        .percent{
          flex: 0 0 auto;
          width: 100px;
        }
      }
    }
    .tr-extra{
      display: flex;
      border-bottom: 1px solid #e1e4e8;
      .extra-content{
        display: flex;
        flex-direction: column;
        flex: 1;
        &:nth-child(1){
          .tr{
            border-right: 1px solid #E1E4E8;;
          }
        }

      }
      .extra-title{
        color: #24292e;
        font-weight: 500;
      }
      &:last-child {
        border-bottom: 0;
      }
      .tr {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        font-size: 14px;
        color: #24292e;
        line-height: 17px;
        border-bottom: 1px solid #e1e4e8;
        & > span {
          flex: 1;
        }
        &:last-child{
          border-bottom: 0;
        }
      }
    }
    .bold {
      font-weight: bold;
    }
    .right-width {
      margin-left: 20px;
      width: 69px;
      text-align: right;
    }
    .flex-algin {
      align-items: center;
      justify-content: flex-end;
    }
  }
  /deep/ .el-checkbox{
    display: inline-block !important;
  }
  .v-radio-group{
    margin-left: 20px;
    display: inline-block;
  }
  .day{
    text-align: center;
    .el-input{
      width: 80px;
    }
  }
  .amount_title{
    flex: 0 0 auto !important;
    width: 200px;
  }
</style>
